import { use, useCallback } from "react";
import type { TrackingEvent } from "../../types/TrackingEvent";
import { MapsContext } from "../../useMaps";

const alreadyThrownEvents: string[] = [];

export function useSendTrackingEvent(): (event: TrackingEvent) => void {
    const mapsContext = use(MapsContext);

    if (mapsContext === undefined) {
        throw new Error(
            "useSendTrackingEvent() was called before MapsContext value was properly initialized.",
        );
    }

    const {
        mapsProps: { onTrackingEvent },
    } = mapsContext;

    return useCallback(
        (event: TrackingEvent) => {
            // Only send tracking events once to minimize amount of send events
            if (alreadyThrownEvents.includes(event.name)) return;

            alreadyThrownEvents.push(event.name);

            // Transform event into simple javascript object because sometimes it is partially a javascript proxy (from valtio) under the hood.
            // Javascript proxies cannot be serialized when they are passed to the native apps via the bridge because of framework limitations
            // the apps use for webview <-> app communication.
            const eventAsSimpleObject = JSON.parse(JSON.stringify(event));

            onTrackingEvent?.(eventAsSimpleObject);
        },
        [onTrackingEvent],
    );
}
